export const AdminDeletionTarget = {
    transaction: 'transaction',
    prestationParticipation: 'prestation-participation',
    prestation: 'prestation',
    prestationTransaction: 'prestation-transaction',
    supplierInvoice: 'supplier-invoice',
    supplierPayment: 'supplier-payment',
};
